import restService from "./rest.service";

async function loginBase(url, credentials) {
    localStorage.clear();

    const response = await restService.postAsync(url, credentials);
    const user = response?.data?.user;
    const token = response?.data?.token ?? response?.data?.accessToken;

    localStorage.setItem("token", token);

    if (user) {
        localStorage.setItem("user", user);
    }

    return response?.data ?? {};
}

//Para que o request funcione corretamente, eh necessario que os parametros estejam com os mesmos nomes do metodo no server
async function loginAsync(credentials) {
    return loginBase("auth/login", credentials);
}

async function loginMedicoAsync(credentials) {
    return loginBase("auth/loginMedico", credentials);
}

async function loginConvenioAsync(credentials) {
    return loginBase("auth/loginConvenio", credentials);
}

async function loginProcedenciaAsync(credentials) {
    return loginBase("auth/loginProcedencia", credentials);
}

async function loginPacienteTokenAsync(credentials) {
    return loginBase("auth/loginToken", credentials);
}

async function loginMedicoTokenAsync(credentials) {
    return loginBase("auth/loginMedicoToken", credentials);
}

async function loginColaborador(credentials) {
    return loginBase("auth/LoginMedicoColaborador", credentials);
}

async function autenticarDoisFatores(credentials) {
    return await restService.postAsync("auth/AutenticarDoisFatores", credentials);
}

async function reenviarDoisFatores(credentials) {
    return await restService.postAsync("auth/ReenviarDoisFatores", credentials);
}

function getResultadosAvisoInicio() {
    return restService.getAsync('auth/GetResultadosAvisoInicio');
}

export default {
    autenticarDoisFatores,
    reenviarDoisFatores,
    loginAsync,
    loginMedicoAsync,
    loginConvenioAsync,
    loginProcedenciaAsync,
    loginPacienteTokenAsync,
    loginMedicoTokenAsync,
    loginColaborador,
    getResultadosAvisoInicio,
};
